<template>
<div class="horizontal-cards" >
<p class="title"  v-if="!hasOptionsTv || isCir">Suggestions</p>
<div style=" height: 100%;" v-if="firstList.length>0">
  <carousel
    navigation-prev-label="<i class='fo-icon-arrow-left'></i>"
    navigation-next-label="<i class='fo-icon-arrow-right'></i>"
    :mouse-drag="true"
    :navigation-enabled="true"
    :pagination-enabled="false"
    @pageChange="pageChanged"
    :per-page-custom="[[320,0.75], [576, 1], [768, 1.5], [992,1], [1200,1]]"
    >
    <slide v-for="(slide, index) in firstList" :key="index"  >
      <div class="div-suggestion ">
        <video-vignette
          :video="firstList[index]"
          :hide="hideElements"
          card-type="default"
          @selected="showVideo(firstList[index])"
          :class="[{'style-image-cards  is-tv-options':hasOptionsTv,'is-formation-options': hasOptionsTv ? videos.length > 0 && hasOptionsFormation : relatedVideos.length > 0 && hasOptionsFormation}]"
        ></video-vignette>
        <video-vignette
          :video="secondList[index]"
          :hide="hideElements"
          card-type="default"
          @selected="showVideo(secondList[index])"
          :class="[{'style-image-cards  is-tv-options':hasOptionsTv,'is-formation-options': hasOptionsTv ? videos.length > 0 && hasOptionsFormation : relatedVideos.length > 0 && hasOptionsFormation}]"
        ></video-vignette>
      </div>
    </slide>
  </carousel>
</div>
  <infinite-loading  :distance="10" v-if="hasOptionsTv && hasVideos && !isEndReached" class="horizontal-cards__infinite-loading">
    <div slot="spinner" >
      <spinner-loader :show-text="false"></spinner-loader>
    </div>
    <div slot="no-more"></div>
  </infinite-loading>
  <div slot="no-results" class="horizontal-cards__infinite-loading" v-show="hasVideos && isEndReached">{{ $t('labels.no_video') }}</div>
</div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { Carousel, Slide } from 'vue-carousel';
  import VideoVignette from '~/node_modules/video-vignette/src/components/Component.vue';
  import SpinnerLoader from './common/SpinnerLoader';
  import InfiniteLoading from 'vue-infinite-loading';

  export default {
name: "HorizantalCardCarousel",
  data() {
    return {

      slides:[],
    };
  },
    components: {
      Carousel,
      Slide,
      VideoVignette,
      SpinnerLoader,
      InfiniteLoading
    },
    props:['mobile', 'desktop'],
    watch:{
      isLoading(isLoading) {
        const pathname = this.$route.name;
        if(this.hasOptionsTv && !this.isCir){
          if (this.currentPage === 2 && !isLoading && this.videos.length > 0 && pathname!=='permalien') {
            this.selectVideo(this.firstList[0]);
          }
        }
      },
    },
  computed:{
    ...mapGetters({
      isHeaderInfo: 'layout/isHeaderInfo',
      videos: 'videos/getAllVideos',
      relatedVideos: 'videos/getRelatedVideos',
      isEndReached: 'videos/getEndReached',
      hasOptionsTv: 'layout/hasOptionsTv',
      currentVideo: 'videos/getCurrentVideo',
      videoMedia: 'videos/getVideoMedia',
      isFullWidth: 'layout/isFullWidth',
      isSideNav: 'layout/isSideNav',
      componentStyle: 'layout/getComponentStyle',
      playerSkin: 'layout/getCurrentSkinPlayer',
      videoLiked: 'videos/getVideoLike',
      videoDisLiked: 'videos/getVideoDisLike',
      isVideoHd: 'layout/getIsVideoHd',
      isPlayerCDN: 'common/isPlayerCDN',
      getNbRatingStar: 'videos/getNbRatingStar',
      isLoading: 'videos/getLoading',
      currentPage: 'videos/getCurrentPage',
      nbLike: 'videos/getNbLike',
      nbDisLike: 'videos/getNbDisLike',
      hasOptions: 'layout/hasOptions',
      hasOptionsFormation: 'layout/hasOptionsFormation',
      currentTheme: 'videos/getCurrentTheme',
      currentCategory: 'videos/getCurrentCategory',
      playerUrl: 'videos/getPlayerUrl',

    }),
    hasVideos(){
      return this.hasOptionsTv && !this.isCir ? this.videos.length===0: this.relatedVideos.length===0;
    },
    getVideos(){
      return this.hasOptionsTv && !this.isCir ? this.videos: this.relatedVideos;
    },
    isCir(){
      return process.env.IS_CIR;
    },
    firstList(){
      return this.getVideos.length > 1 ? this.getVideos.filter((x,index)=> index % 2 ===0) : this.getVideos
    },
    secondList(){
      return this.getVideos.length > 1 ?  this.getVideos.filter((x,index)=> index % 2 !==0) : []
    },
    hideElements(){
      if(this.hasOptions){
        return ['duration']
      }
      else if(this.hasOptionsFormation){
        return ['date']
      }
      else if(this.hasOptionsTv){
        return ['nbViews']
      }
      else{
        return ['date'];
      }
    },
  },

  methods: {

    ...mapActions('videos', [
      'paginateVideos',
      'setCurrentVideo',
      'getVideoMediaById',
      'fetchRelated',
      'handlePagination'
    ]),
    selectVideo(video) {
      this.$Progress.start();
      this.setCurrentVideo(video);
      if (!this.isHeaderInfo) {
        this.getVideoMediaById(video.id);
      }
    },
    showVideo(selected){

      console.log("slide",selected)
      this.$Progress.start();
      this.setCurrentVideo(selected);
      if (!this.isHeaderInfo) {
        this.getVideoMediaById(selected.id);
      }
      console.log("selected",selected)
      this.$emit('selected', selected);
    },
    async pageChanged(page) {
      let length;
      length =this.hasOptionsTv && !this.isCir ? this.videos.length: this.relatedVideos.length;
      let nbPage=( this.hasOptionsTv && !this.isCir ? 2 : 8);
      let hasPaginate=page * nbPage >= length - (this.hasOptionsTv && !this.isCir ? nbPage : 4);
     if(page > 0){
       if ((!this.isEndReached ) &&  hasPaginate ) {
           await this.handlePagination(true)
           await this.paginateVideos();
       } else {
         return;
       }
     }
    },
  },

    mounted(){
    },
    created(){
    },

}
</script>

<style lang="scss" scoped>
  @import '../assets/scss/_variables';
  @import '../assets/scss/mix.scss';
  .horizontal-cards{
    height: 100%;
    &__infinite-loading{
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }
    .title {

      height: 0px;
      color: #A31A3E;
      font-weight: bold;
      font-size: 24px;
      padding-left: 0.25em;
    }
    .VueCarousel-navigation-button {
      position: absolute;
      top: 50%;
      box-sizing: border-box;
      color: #000;
      text-decoration: none;
      appearance: none;
      border: none;
      background-color: transparent;
      padding: 0;
      cursor: pointer;
      outline: none;
    }
   /deep/ .card-wrapper {
      .card {
        .card-title {
          @include hasColorTitre(var(--title-color));
          height: 1.2em;
        }
        .card-text {
          margin-bottom:1.5rem;
          font-size: 0.8em;
          color: #555;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          overflow: hidden;
          -o-text-overflow: ellipsis;
          line-height: 1.2em;
          height: 2.4em;
        }
        margin-bottom: 30px;
        .tag-info {
          font-size: 0.8em;
        }
      }
        .is-tv-options{
          padding: 0 0.5em;
        }

    }

    /deep/ .VueCarousel {
      padding: 0 0.5em;
      border-radius: 0.15rem;
      margin-top: 1em;
      align-items: center;
      align-content: center;
      // right: 2em;
      position: relative;
      width: 100%;
      .VueCarousel-wrapper {
        width: 100%;
        .VueCarousel-slide {
          padding: 0 !important;
          margin-top: 1em;

        }
        .style-image-cards{
          /deep/  .img-wrapper{
            .card-img-top{
              border-radius: 10px !important;
              opacity: 1;
              padding: 5px;
            }
            .crad-text{
              margin-bottom: 1.5rem;
              font-size: 0.8em;
              color: #555;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              overflow: hidden;
              -o-text-overflow: ellipsis;
              line-height: 1.2em;
              height: 2.4em;
              word-break: break-word;
            }
            &:after{
              position: relative;
            }
          }
          .tag-info .icon.duration {
            display: none;
          }
          &.is-tv-options{

            /deep/  .card-date{
              .date{
                display: none;
              }
              background: #CBCECF 0% 0% no-repeat padding-box;
              border-radius: 3px;
              opacity: 1;
              position: absolute;
              left: 0.8rem;
              bottom: 0.5rem;
              color: white;
              padding: 0 0.4em;
              @media screen and (max-width: 1080px) and (min-width:992px){
                padding: 0 0.2em !important;
              }
            }
            /deep/  .card-duration{
              background: #CBCECF 0% 0% no-repeat padding-box;
              border-radius: 3px;
              opacity: 1;
              position: absolute;
              right: 0.8rem;
              bottom: 0.5rem;
              color: white;
              padding: 0 0.4em;
              @media screen and (max-width: 1080px) and (min-width:992px){
                padding: 0 0.2em !important;
              }
            }
          }

        }
      }
      .VueCarousel-navigation {
        position: absolute;
        bottom: 0;
        right: 3.5em;
        .VueCarousel-navigation-button {
          display: block;
          width: 3em;
          height: 3em;
          background-size: contain;

          border-radius: 1.5em;
          background-size: 1.5em;
          box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2);
          outline: none !important;
          color: var(--primary-color) !important;
          &.VueCarousel-navigation-prev {
            border-bottom-left-radius: 0.2em;
            border-top-left-radius: 0.2em;
            border-bottom-right-radius: 0;
            border-top-right-radius: 0;
            background-color: white;
            color: #495057 !important;
            width: 47px;
            height: 36px;
            border: 1px solid #6F6F6F;
            left: 0em!important;
          }
          &.VueCarousel-navigation-next {
            right: 0em !important;
            border-bottom-left-radius: 0em;
            border-top-left-radius: 0em;
            border-bottom-right-radius: 0.2em;
            border-top-right-radius: 0.2em;
            color: #495057 !important;
            width: 47px;
            height: 36px;
            border: 1px solid #6F6F6F;
          }
        }
      }
    }


    @media (min-width: 769px) and (max-width: 992px)
    {

      .div-suggestion{
        display: flex;
        position: relative;
        align-items: center;
        align-content: center;
        flex-direction: row !important;


      }
      .VueCarousel .VueCarousel-wrapper .VueCarousel-slide {

      }
      /deep/ .VueCarousel {

        width: 100%;

        padding: 0 0.1em;
        .VueCarousel-navigation {
          display: none;
        }
      }

      .card-wrapper{
        height: 100%;
        width: 100%;
        /*margin-right: 3%;;*/
        padding: 1em 0.5em;
      }

    }
    @media (min-width: 579px) and (max-width: 769px)
    {

      .div-suggestion{
        display: flex;
        position: relative;
        align-items: center;
        align-content: center;
        flex-direction: row !important;


      }
      /deep/ .VueCarousel {
        width:100%;
        .VueCarousel-navigation {
          display: none;
        }
      }
      .card-slide{
        margin-left: 0.5em;
      }
      .card{
        max-width: 19.5rem !important;
        margin-right: 0.75em;
      }
      .img-card{
        width: 299px;
        height: 168px;
      }
      .div-title{
        height: 14px !important;
      }
      .card-wrapper{
        height: 100%;
        width: 100%;
        /*margin-right: 3%;;*/
        padding: 1em 0.5em;
      }
    }
    @media (min-width: 320px) and (max-width: 579px)  {
      .div-suggestion{
        display: flex;
        position: relative;
        align-items: center;
        align-content: center;
        flex-direction: row !important;

      }
      .VueCarousel .VueCarousel-wrapper .VueCarousel-slide {
        margin-right: -0.3em;
      }
      /deep/ .VueCarousel {
        width: 100%;
        .VueCarousel-navigation {
          display: none;
        }
      }
      .card{
        max-width: 14rem !important;
        max-height: 15.75em;
        margin-right: 1em;
      }
      .img-card{
        width: 212px;
        height: 120px;
      }
      .card-wrapper{
        height: 100%;
        width: 100%;
        /*margin-right: 3%;;*/
        padding: 1em 0.5em;
      }
    }
    @media (max-width: 320px) {
      .div-suggestion{
        display: flex;
        position: relative;
        align-items: center;
        align-content: center;
        flex-direction: row !important;

      }
      .VueCarousel .VueCarousel-wrapper .VueCarousel-slide {
        margin-right: -0.3em;
      }
      /deep/ .VueCarousel {

        width: 100%;
        .VueCarousel-navigation {
          display: none;
        }
      }
      .card{
        max-width: 14rem !important;
        max-height: 15.75em;
        margin-right: 1em;
      }
      .img-card{
        width: 212px;
        height: 120px;
      }
    }
    .hour-txt{
      width: 52px;
      position: absolute;
      right: 0;
      float: right;
    }
    .card-body{
      padding: 0.95rem;
    }
    .div-desc{
      display: block;
      width: 100%;
      height: 35px;
    }
    .div-title{
      display: block;
      width: 100%;
      height: 24px;
    }
    .div-title{
      height: 25px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/HorizantalCardCarousel.vue